import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import useIsBrowser from 'hooks/useIsBrowser';
import { GET_LOCATION_FROM_COORDS } from 'mocks/queries';
import getCityAndCountryFromAddress from './getCityAndCountryFromAddress';
const DEFAULT_VALUE = {
  location: undefined,
  error: undefined,
  isLoading: false
};
const useUserLocationFromCoords = t0 => {
  const $ = _c(24);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    latitude: latitudeString,
    longitude: longitudeString
  } = t1;
  const isBrowser = useIsBrowser();
  let t2;
  if ($[2] !== latitudeString) {
    t2 = latitudeString ? parseFloat(parseFloat(latitudeString).toFixed(4)) : undefined;
    $[2] = latitudeString;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const latitude = t2;
  let t3;
  if ($[4] !== longitudeString) {
    t3 = longitudeString ? parseFloat(parseFloat(longitudeString).toFixed(4)) : undefined;
    $[4] = longitudeString;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const longitude = t3;
  let t4;
  if ($[6] !== latitude || $[7] !== longitude) {
    t4 = !!latitude && !!longitude ? {
      latitude,
      longitude
    } : undefined;
    $[6] = latitude;
    $[7] = longitude;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const variables = t4;
  const t5 = !variables;
  let t6;
  if ($[9] !== t5 || $[10] !== variables) {
    t6 = {
      variables,
      skip: t5
    };
    $[9] = t5;
    $[10] = variables;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const {
    loading,
    data,
    error
  } = useSuspenseQuery(GET_LOCATION_FROM_COORDS, t6);
  const isLoading = loading && !data;
  const locationResponse = data?.getLocationFromCoords;
  let t7;
  bb0: {
    if (!locationResponse) {
      t7 = undefined;
      break bb0;
    }
    const {
      address,
      state,
      stateShortName,
      zip
    } = locationResponse;
    let t8;
    if ($[12] !== address) {
      t8 = getCityAndCountryFromAddress(address);
      $[12] = address;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    const {
      city,
      country
    } = t8;
    let t9;
    if ($[14] !== city || $[15] !== country || $[16] !== state || $[17] !== stateShortName || $[18] !== zip) {
      t9 = {
        city,
        country,
        state,
        stateShortName,
        zip
      };
      $[14] = city;
      $[15] = country;
      $[16] = state;
      $[17] = stateShortName;
      $[18] = zip;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    t7 = t9;
  }
  const location = t7;
  if (!isBrowser) {
    return DEFAULT_VALUE;
  }
  let t8;
  if ($[20] !== error || $[21] !== isLoading || $[22] !== location) {
    t8 = {
      location,
      error,
      isLoading
    };
    $[20] = error;
    $[21] = isLoading;
    $[22] = location;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default useUserLocationFromCoords;